import { API_BASE, PAGOS_API_URL } from "../config";

// Datos que muestra la pantalla "Acerca de". Los datos del build los pone scripts/build.js
// al hacer "npm run build"; en desarrollo ("npm start") no existen.

export const NOMBRE_SISTEMA = "Sistema de Pagos";
export const INSTITUCION = "CECyTE Jalisco";

// Nombres de los roles del panel del cajero (tabla tblmultipagos_roles)
export const NOMBRES_ROL = { "1": "Administrador", "2": "CajeroPinpad", "3": "CajeroTPV" };

// Hosts del sitio, tomados de la configuracion del proyecto:
// produccion = homepage de package.json; Dev = dev-multipagos.cecytejalisco.edu.mx.
const HOST_PRODUCCION = "multipagos.cecytejalisco.edu.mx";

export const ENTORNO_LOCAL = "Equipo local (pruebas)";
export const ENTORNO_DEV = "Desarrollo (Dev)";
export const ENTORNO_PRODUCCION = "Producción";

export function entornoDesdeHost(host) {
  const h = String(host || "").toLowerCase().replace(/:\d+$/, "");
  if (!h) return "No identificado";
  if (h === "localhost" || h === "127.0.0.1" || h === "[::1]" || h.endsWith(".localhost")) {
    return ENTORNO_LOCAL;
  }
  if (h === HOST_PRODUCCION) return ENTORNO_PRODUCCION;
  if (h.startsWith("dev-")) return ENTORNO_DEV;
  return `Otro sitio (${h})`;
}

// "dd/mm/aaaa hh:mm" en la hora local de quien lo ve; vacio si la fecha no es valida
export function formatearFecha(iso) {
  const f = new Date(iso);
  if (!iso || Number.isNaN(f.getTime())) return "";
  const dos = (n) => String(n).padStart(2, "0");
  return `${dos(f.getDate())}/${dos(f.getMonth() + 1)}/${f.getFullYear()} ${dos(f.getHours())}:${dos(f.getMinutes())}`;
}

// host (y puerto) de una URL; el texto original si no se puede leer
export function hostDeUrl(url) {
  try {
    return new URL(url).host;
  } catch (error) {
    return String(url || "");
  }
}

const esLocal = (host) => /^(localhost|127\.0\.0\.1|\[::1\])(:\d+)?$/i.test(host);

// Todo lo que muestra "Acerca de"; los parametros permiten probar la funcion sin depender del build.
export function obtenerInfoSistema({
  env = process.env,
  host = typeof window !== "undefined" ? window.location.host : "",
  apiBase = API_BASE,
  pagosUrl = PAGOS_API_URL,
  almacen = typeof localStorage !== "undefined" ? localStorage : null,
} = {}) {
  const hostApi = hostDeUrl(apiBase);
  const hostPagos = hostDeUrl(pagosUrl);
  const idBuild = env.REACT_APP_BUILD_ID || "";
  const entorno = entornoDesdeHost(host);

  let sesion = null;
  try {
    if (almacen && almacen.getItem("cajero_token")) {
      const rol = almacen.getItem("cajero_rol") || "";
      sesion = {
        nombre: almacen.getItem("cajero_nombre") || "",
        rol: NOMBRES_ROL[rol] || (rol ? `Rol ${rol}` : ""),
        plantel: almacen.getItem("cajero_nombre_plantel") || "",
      };
    }
  } catch (error) {
    sesion = null;
  }

  return {
    sistema: NOMBRE_SISTEMA,
    institucion: INSTITUCION,
    idBuild,
    fechaBuild: formatearFecha(env.REACT_APP_BUILD_FECHA),
    commit: env.REACT_APP_BUILD_COMMIT || "",
    rama: env.REACT_APP_BUILD_RAMA || "",
    entorno,
    // En produccion (y en cualquier sitio no reconocido) solo se muestran la version y su
    // identificador; el detalle tecnico (rama, commit, servidores, sesion) solo en Dev y local.
    mostrarDetalle: entorno === ENTORNO_LOCAL || entorno === ENTORNO_DEV,
    sitio: host,
    servidorDatos: hostApi + (esLocal(hostApi) ? " (pruebas locales)" : ""),
    servidorPagos: hostPagos + (esLocal(hostPagos) ? " (pruebas locales)" : ""),
    sesion,
  };
}
